import React,{useState} from 'react'
import {locationService} from '../services/locationService'
export default function FamilyGeo(){
 const [position,setPosition]=useState(null)
 const [error,setError]=useState('')
 const [loading,setLoading]=useState(false)
 const load=async()=>{setLoading(true);setError('');try{setPosition(await locationService.getCurrentPosition())}catch(e){setError(e.message||'Localização indisponível')}finally{setLoading(false)}}
 return <div className="p-6 max-w-3xl mx-auto space-y-5">
  <h1 className="text-2xl font-bold">📍 Localização da Família</h1>
  <p className="text-neutral-700">A localização atual só é apresentada neste dispositivo. A partilha entre familiares exige consentimento e está em migração.</p>
  <button className="btn-primary" disabled={loading} onClick={load}>{loading?'A localizar...':'Ver a minha localização'}</button>
  {position&&<div className="rounded-xl border p-4"><p>Latitude: {position.lat.toFixed(5)}</p><p>Longitude: {position.lng.toFixed(5)}</p><p>Precisão aproximada: {Math.round(position.accuracy)} metros</p></div>}
  {error&&<p role="alert" className="text-red-700">{error}</p>}
  <div className="rounded-xl border border-amber-300 bg-amber-50 p-4"><strong>Alertas SOS:</strong> a distribuição automática aos familiares está temporariamente indisponível. Em emergência, contacte os serviços locais de emergência (112 em Portugal e na União Europeia).</div>
 </div>
}
